module.exports = __webpack_public_path__ + "static/media/registration.f53ae9f5.svg";